export default "__VITE_ASSET__56429b11__"